export default {
  descricao: {
    value: null,
    maxlength: 45,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/serviceanalysistec/serviceanalysistec-form.js